import { KEY_ENTER, KEY_ESCAPE, KEY_RETURN } from 'keycode-js';

const suppressKeyboardEvent = ({ event: { keyCode }, editing }) =>
    editing && [KEY_RETURN, KEY_ENTER, KEY_ESCAPE].includes(keyCode);

export default suppressKeyboardEvent;
